<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="5">
        <el-card class="card">
          <div slot="header"
               class="card-header">
            <i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>组织
          </div>
          <div style="overflow: auto; height: calc(100vh - 179px)">
            <es-org-tree @clickByOrg="queryFaultList"
                         @completed="initOrgTree"></es-org-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-card class="card">
          <div slot="header"
               class="card-header">
            <i class="el-icon-font el-icon-shebeizuguanli el-icon--left"></i>故障
          </div>
          <div class="es-op-box">
            <el-date-picker style="float: left; width: 280px"
                            format="yyyy-MM-dd"
                            v-model="dateTime"
                            type="daterange"
                            size="small"
                            class="query"
                            range-separator="至"
                            start-placeholder="上报日期开始"
                            end-placeholder="上报日期结束"
                            clearable
                            @clear="
                () => {
                  this.dateTime = [];
                }
              "
                            @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadFaultList();
                }
              ">
            </el-date-picker>
            <el-select style="float: left"
                       class="query"
                       size="small"
                       v-model="queryObj.systemId"
                       placeholder="请选择系统专业"
                       clearable
                       filterable
                       @clear="
                () => {
                  delete this.queryObj.systemId;
                }
              "
                       @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadFaultList();
                }
              ">
              <el-option v-for="item in systems"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
            <el-select style="float: left"
                       class="query"
                       size="small"
                       v-model="queryState"
                       placeholder="请选择状态"
                       clearable
                       filterable
                       @clear="
                () => {
                  this.queryState = null;
                }
              "
                       @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadFaultList();
                }
              ">
              <el-option v-for="item in statesArr"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
            <el-input placeholder="请输入故障单号"
                      v-model="queryObj.keyWord"
                      size="small"
                      class="query"
                      style="float: left"
                      clearable
                      @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadFaultList();
                }
              ">
              <i slot="suffix"
                 class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button type="primary"
                       icon="el-icon-font el-icon-web__tianjia"
                       size="mini"
                       style="margin-right: 6px"
                       @click="add_init">新增</el-button>
          </div>
          <el-table :data="pageData.list"
                    ref="faultTable"
                    show-overflow-tooltip
                    border
                    stripe
                    size="mini"
                    height="calc(100vh - 250px)"
                    v-loading="loading">
            <el-table-column type="index"
                             label="序号"
                             width="50"
                             align="center">
            </el-table-column>

            <el-table-column prop="code"
                             label="故障单号"> </el-table-column>
            <el-table-column prop="systemName"
                             label="系统专业">
            </el-table-column>
            <el-table-column prop="orgName"
                             label="所属组织"> </el-table-column>
            <el-table-column prop="equiName"
                             label="设备名称">
            </el-table-column>
            <el-table-column prop="occuTime"
                             label="上报时间">
            </el-table-column>
            <el-table-column prop="duration"
                             label="规定时长">
              <template slot-scope="scope">
                <span style="color: orange">{{ scope.row.duration }}小时</span>
              </template>
            </el-table-column>
            <el-table-column prop="planSolveTime"
                             label="规定完成时间">
              <template slot-scope="scope">
                <span style="color: orange">{{ scope.row.planSolveTime }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="appeName"
                             :show-overflow-tooltip="true"
                             label="故障现象">
            </el-table-column>
            <el-table-column prop="state"
                             label="状态"
                             width="70"
                             align="center">
              <template slot-scope="scope">
                <el-tag size="mini"
                        :type="stateFormat(scope.row, 1)">{{
                  scope.row.statename
                }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作"
                             width="80"
                             align="center">
              <template slot-scope="scope">
                <el-link :underline="false"
                         title="详情"
                         @click="view(scope.row)"
                         type="success"><i class="el-icon-font el-icon-view"></i></el-link>
                <el-divider direction="vertical"></el-divider>
                <es-delete @del="del(scope.row.id)"
                           v-if="scope.row.state == 3 || scope.row.isActived == 1"
                           disabled
                           type="icon"></es-delete>
                <es-delete @del="del(scope.row.id)"
                           v-else
                           type="icon">
                </es-delete>
              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="pageData"
                           @change="
                (cpage) => {
                  this.queryObj.pageNum = cpage;
                  this.loadFaultList();
                }
              ">
            </es-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!--编辑故障-->
    <el-dialog :visible.sync="editVisible"
               @closed="
        () => {
          this.$refs['faultForm'].clearValidate();
          this.fileList = [];
        }
      "
               width="1200px"
               style="padding-top: 0px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑故障
      </span>
      <div v-loading="editLoading">
        <el-form :model="faultInfo"
                 :inline="true"
                 :rules="rules"
                 size="mini"
                 label-position="right"
                 label-width="150px"
                 ref="faultForm">
          <el-form-item prop="code"
                        label="设备编码">
            <el-input placeholder="请输入设备编码"
                      prefix-icon="el-icon-search"
                      v-model="assetCode"
                      style="width: 200px"
                      clearable
                      @change="
                () => {
                  loadAssetById();
                }
              ">
            </el-input>
          </el-form-item>

          <el-form-item prop="orgId"
                        label="所属组织">
            <el-cascader ref="orgId"
                         v-model="faultInfo.orgId"
                         :show-all-levels="false"
                         :props="{ value: 'id', checkStrictly: true }"
                         :options="orgTree"
                         filterable
                         @change="
                () => {
                  this.loadAreaListAll();
                  this.$set(this.faultInfo, 'areaId', null);
                  this.$set(this.faultInfo, 'equiId', null);
                  this.$set(this.faultInfo, 'equiTypeId', null);
                }
              "
                         style="width: 200px"></el-cascader>
          </el-form-item>
          <el-form-item prop="areaId"
                        label="所属区域">
            <el-select ref="areaSelect"
                       style="width: 200px"
                       v-model="faultInfo.areaId"
                       placeholder="请选择所属区域"
                       clearable
                       filterable
                       @change="
                () => {
                  this.loadAssetListAll();
                  this.$set(this.faultInfo, 'equiTypeId', null);
                  this.$set(this.faultInfo, 'equiId', null);
                }
              ">
              <el-option v-for="item in areas"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="equiTypeId"
                        label="设备类型">
            <el-select ref="typeSelect"
                       style="width: 200px"
                       disabled
                       v-model="faultInfo.equiTypeId"
                       placeholder=""
                       @change="typeSelectChange"
                       clearable
                       filterable>
              <el-option v-for="item in types"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="equiId"
                        label="设备名称">
            <el-select ref="equiSelect"
                       style="width: 200px"
                       v-model="faultInfo.equiId"
                       placeholder="请选择设备名称"
                       @change="equiSelectChange"
                       clearable
                       filterable>
              <el-option v-for="item in assets"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="equiModuleId"
                        label="设备模块">
            <el-select ref="equiModuleSelect"
                       style="width: 200px"
                       v-model="faultInfo.equiModuleId"
                       placeholder="请选择设备模块"
                       clearable
                       filterable>
              <el-option v-for="item in modules"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="reporteName"
                        label="上报人">
            <el-input v-model="faultInfo.reporteName"
                      placeholder="上报人"
                      style="width: 200px"
                      clearable>
            </el-input>
          </el-form-item>
          <el-form-item prop="resolverId"
                        label="解决人">
            <el-select ref="resolverSelect"
                       style="width: 200px"
                       v-model="faultInfo.resolverId"
                       placeholder="请选择解决人"
                       clearable
                       filterable>
              <el-option v-for="item in resolvers"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="occuTime"
                        label="上报时间">
            <el-date-picker v-model="faultInfo.occuTime"
                            type="datetime"
                            format="yyyy-MM-dd HH:mm"
                            value-format="yyyy-MM-dd HH:mm"
                            style="width: 200px"
                            placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="levelName"
                        label="故障等级">
            <el-input v-model="faultInfo.levelName"
                      :disabled="true"
                      style="width: 200px">
            </el-input>
          </el-form-item>
          <el-form-item prop="appeId"
                        label="故障现象">
            <el-select ref="appeSelect"
                       style="width: 200px"
                       v-model="faultInfo.appeId"
                       placeholder="请选择故障现象"
                       @change="
                () => {
                  this.$set(this.faultInfo, 'duration', null);
                  this.levelId = [];
                  this.$set(this.faultInfo, 'levelName', null);
                  this.findAppeAndLevelByid();
                }
              "
                       clearable
                       filterable>
              <el-option v-for="item in appes"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="des"
                        label="故障描述">
            <el-input v-model="faultInfo.des"
                      placeholder="故障描述"
                      type="textarea"
                      :rows="2"
                      style="width: 200px"
                      clearable>
            </el-input>
          </el-form-item>
          <el-form-item prop="duration"
                        label="规定时长">
            <el-input v-model="faultInfo.duration"
                      :disabled="true"
                      style="width: 200px">
            </el-input>
          </el-form-item>
          <!-- 扩展属性 -->
          <es-extend :extendMetaData="extendMetaData"
                     :extendData="extendData"
                     idName="faultId"
                     :idValue="faultInfo.id"
                     type="edit"
                     @changeData="insertExtendData">
          </es-extend>
        </el-form>
      </div>
      <span slot="footer">
        <el-button size="mini"
                   @click="editVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="submitFault()"
                   :loading="saving">保 存</el-button>
      </span>
    </el-dialog>

    <!--查看详情-->
    <el-dialog :visible.sync="viewVisible"
               width="1200px"
               style="padding-top: 0px">
      <span slot="title">
        <i class="el-icon-font el-icon-view el-icon--left"></i>故障详情
      </span>

      <el-tabs type="card">
        <el-tab-pane label="基本信息">
          <div v-loading="viewLoading">
            <el-descriptions :column="3"
                             style="cursor: pointer; margin-bottom: 12px"
                             size="mini"
                             border>
              <el-descriptions-item label="故障单号"
                                    :labelStyle='labelStyle'
                                    v-if="faultInfo.code != '' && faultInfo.code != null">{{ faultInfo.code }}</el-descriptions-item>
              <el-descriptions-item label="所属组织"
                                    :labelStyle='labelStyle'
                                    v-if="faultInfo.orgName != '' && faultInfo.orgName != null">{{ faultInfo.orgName }}</el-descriptions-item>
              <el-descriptions-item label="所属区域"
                                    :labelStyle='labelStyle'
                                    v-if="faultInfo.areaName != '' && faultInfo.areaName != null">{{ faultInfo.areaName }}</el-descriptions-item>
              <el-descriptions-item label="所属系统"
                                    :labelStyle='labelStyle'
                                    v-if="
                  faultInfo.systemName != '' && faultInfo.systemName != null
                ">{{ faultInfo.systemName }}</el-descriptions-item>
              <el-descriptions-item label="设备类型"
                                    :labelStyle='labelStyle'
                                    v-if="
                  faultInfo.equiTypeName != '' && faultInfo.equiTypeName != null
                ">{{ faultInfo.equiTypeName }}</el-descriptions-item>
              <el-descriptions-item label="设备型号"
                                    :labelStyle='labelStyle'
                                    v-if="
                  faultInfo.equiModelName != '' &&
                  faultInfo.equiModelName != null
                ">{{ faultInfo.equiModelName }}</el-descriptions-item>
              <el-descriptions-item :labelStyle='labelStyle'
                                    label="设备名称"
                                    v-if="faultInfo.equiName != '' && faultInfo.equiName != null">{{ faultInfo.equiName }}</el-descriptions-item>
              <el-descriptions-item label="设备模块"
                                    :labelStyle='labelStyle'
                                    v-if="
                  faultInfo.equiModuleName != '' &&
                  faultInfo.equiModuleName != null
                ">{{ faultInfo.equiModuleName }}</el-descriptions-item>
              <el-descriptions-item label="上报时间"
                                    :labelStyle='labelStyle'
                                    v-if="faultInfo.occuTime != '' && faultInfo.occuTime != null">{{ faultInfo.occuTime }}</el-descriptions-item>
              <el-descriptions-item label="上报人"
                                    :labelStyle='labelStyle'
                                    v-if="
                  faultInfo.reporteName != '' && faultInfo.reporteName != null
                ">{{ faultInfo.reporteName }}</el-descriptions-item>
              <el-descriptions-item label="解决人"
                                    :labelStyle='labelStyle'
                                    v-if="
                  faultInfo.resolverName != '' && faultInfo.resolverName != null
                ">{{ faultInfo.resolverName }}</el-descriptions-item>
              <el-descriptions-item label="协作人"
                                    :labelStyle='labelStyle'
                                    v-if="
                  faultInfo.companionName != '' &&
                  faultInfo.companionName != null
                ">{{ faultInfo.companionName }}</el-descriptions-item>
              <el-descriptions-item label="规定解决时长"
                                    :labelStyle='labelStyle'
                                    v-if="faultInfo.duration != '' && faultInfo.duration != null">{{ faultInfo.duration }}</el-descriptions-item>
              <el-descriptions-item label="规定解决时间"
                                    :labelStyle='labelStyle'
                                    v-if="
                  faultInfo.planSolveTime != '' &&
                  faultInfo.planSolveTime != null
                ">{{ faultInfo.planSolveTime }}</el-descriptions-item>
              <el-descriptions-item label="故障等级"
                                    :labelStyle='labelStyle'
                                    v-if="faultInfo.levelName != '' && faultInfo.levelName != null">{{ faultInfo.levelName }}</el-descriptions-item>
              <el-descriptions-item label="故障现象"
                                    :labelStyle='labelStyle'
                                    v-if="faultInfo.appeName != '' && faultInfo.appeName != null">{{ faultInfo.appeName }}</el-descriptions-item>
              <el-descriptions-item label="故障描述"
                                    :labelStyle='labelStyle'
                                    v-if="faultInfo.des != '' && faultInfo.des != null">{{ faultInfo.des }}</el-descriptions-item>
              <el-descriptions-item label="当前状态"
                                    :labelStyle='labelStyle'>
                <div style="width: 200px">
                  <el-tag>{{ stateFormat(faultInfo, 2) }}</el-tag>
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="是否专工"
                                    :labelStyle='labelStyle'>
                <div style="width: 200px">
                  <el-tag>{{ isProfFormat(faultInfo) }}</el-tag>
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="是否曾经激活"
                                    :labelStyle='labelStyle'>
                <div style="width: 200px">
                  <el-tag>{{ isActivedFormat(faultInfo) }}</el-tag>
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="来源"
                                    :labelStyle='labelStyle'>
                <div style="width: 200px">
                  <el-tag>{{ sourceFormat(faultInfo) }}</el-tag>
                </div>
              </el-descriptions-item>
            </el-descriptions>

            <es-img :info="faultInfo"
                    :fileList="fileListView"
                    type="view"></es-img>

            <!-- 扩展属性 -->
            <es-extend :extendData="extendData"
                       type="view"></es-extend>
          </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer">
        <el-button size="mini"
                   type="primary"
                   @click="viewVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import esExtend from "../common/es-extend.vue";
import dateutils from "../../utils/dateutils.js";

export default {
  components: { esExtend },
  name: "fault",
  props: ["funcs"],
  data () {
    return {
      //label样式
      labelStyle: { 'width': '120px' },
      orgTree: [], //所属组织
      areas: [], //区域
      assets: [], //设备
      assetInfo: {}, //设备对象信息
      statesArr: [
        { id: 1, name: "待分配" },
        { id: 2, name: "待解决" },
      ], //状态
      queryState: null,
      systems: [], //系统专业
      dateTime: [], //上报起止日期
      types: [], //设备类型
      modules: [], //设备模块
      appes: [], //故障现象
      levels: [], //故障等级
      resolvers: [], //解决人
      queryObj: { pageNum: 1, pageSize: 20 }, //查询条件
      assetCode: "", //查询条件，定位设备
      pageData: {},
      editVisible: false,
      faultInfo: {}, //故障信息

      extendMetaData: [],
      extendData: [],
      viewVisible: false,
      loading: false,
      editLoading: false,
      viewLoading: false,
      saving: false,
      url: "",
      fileList: [],
      fileListView: [],
      resolverIdArr: [], //解决人
      rules: {
        //验证条件
        equiId: [{ required: true, message: "请选择设备", trigger: "blur" }],
        appeId: [
          { required: true, message: "请选择故障现象", trigger: "blur" },
        ],

        reporteName: [
          { required: true, message: "请输入上报人", trigger: "blur" },
          { max: 20, message: "不能超过20个字符", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    //页面初始化
    init () {
      this.loadSystemListAll();
      this.loadTypeListAll();

      this.loadFaultList();
    },

    //将控件数据回写到父类
    insertExtendData (exdata, data) {
      this.faultInfo.extendData = exdata;
      //前台验证使用
      for (let key in data) {
        this.$set(this.faultInfo, key, data[key]);
      }
    },

    initOrgTree (orgTree) {
      this.orgTree = orgTree;
    },

    //初始化系统下拉框
    loadSystemListAll () {
      this.$ajax
        .get("/base/system/list_all")
        .then((msg) => {
          this.systems = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //初始化设备类型下拉框
    loadTypeListAll () {
      this.$ajax
        .get("/base/assettype/list_all")
        .then((msg) => {
          this.types = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    //根据设备code查询设备
    loadAssetById () {
      this.assets = [];
      this.areas = [];
      this.appes = [];
      this.modules = [];
      this.resolvers = [];
      this.$set(this.faultInfo, "orgId", null);
      this.$set(this.faultInfo, "areaId", null);
      this.$set(this.faultInfo, "equiTypeId", null);
      this.$set(this.faultInfo, "equiId", null);
      this.$set(this.faultInfo, "appeId", null);
      this.$set(this.faultInfo, "equiModuleId", null);
      this.$set(this.faultInfo, "resolverId", null);
      if (this.assetCode != "") {
        this.$ajax
          .get("/base/asset/load_detail", { code: this.assetCode })
          .then((msg) => {
            if (msg != null) {
              this.faultInfo.orgId = msg.orgId;
              this.loadAreaListAll();
              this.faultInfo.areaId = msg.areaId;
              this.faultInfo.equiTypeId = msg.typeId;
              this.faultInfo.equiId = msg.id;

              this.assetInfo = msg;
              this.assets.push(this.assetInfo);

              this.loadModuleListAll(); //加载设备模块
              this.loadFauAppeListAll(); //加载故障现象
              this.loadResolverListAll(); //加载解决人
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
      }
    },

    //根据根据多个条件查询设备
    loadAssetListAll () {
      this.assets = [];
      this.modules = [];
      this.appes = [];
      this.$set(this.faultInfo, "equiModuleId", null);
      this.$set(this.faultInfo, "appeId", null);

      if (this.faultInfo.areaId != null && this.faultInfo.areaId != "") {
        this.$ajax
          .get("/base/asset/list_no_page", {
            areaId: this.faultInfo.areaId,
            typeId: this.faultInfo.equiTypeId,
          })
          .then((msg) => {
            this.assets = msg;
          })
          .catch((err) => {
            this.$message.error(err);
          });
      }
    },

    typeSelectChange () {
      this.loadModuleListAll();
      this.loadFauAppeListAll();
      this.loadAssetListAll();
      this.$set(this.faultInfo, "equiModuleId", null);
      this.$set(this.faultInfo, "appeId", null);
    },

    //选中设备时，把选中的设备赋给设备对象，同时更新界面上设备相关的信息
    equiSelectChange () {
      for (let i = 0, len = this.assets.length; i < len; i++) {
        if (this.assets[i].id == this.faultInfo.equiId) {
          this.assetInfo = this.assets[i];
          break;
        }
      }
      this.faultInfo.equiTypeId = this.assetInfo.typeId;
      this.assetCode = this.assetInfo.code;
      this.typeSelectChange();
      this.loadResolverListAll(); //加载解决人下拉框
    },

    //加载解决人下拉框
    loadResolverListAll () {
      this.resolvers = [];
      this.$set(this.faultInfo, "resolverId", null);
      this.$ajax
        .get("/base/account/list_charge_person", {
          systemId: this.assetInfo.systemId,
          orgId: this.assetInfo.orgId,
        })
        .then((msg) => {
          this.resolvers = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    //从后台查询故障列表
    loadFaultList () {
      this.loading = true;

      this.$set(this.queryObj, "occuTimeStart", null);
      this.$set(this.queryObj, "occuTimeEnd", null);
      //上报起止日期格式化
      if (this.dateTime != null && this.dateTime.length != 0) {
        this.$set(
          this.queryObj,
          "occuTimeStart",
          dateutils.dateFormat("YYYY-mm-dd", this.dateTime[0]) + " 00:00:00"
        );
        this.$set(
          this.queryObj,
          "occuTimeEnd",
          dateutils.dateFormat("YYYY-mm-dd", this.dateTime[1]) + " 23:59:59"
        );
      }

      this.$set(this.queryObj, "orderBy", "state asc,create_time desc");

      //故障上报界面只显示待分配和待解决故障
      if (this.queryState == null || this.queryState == "") {
        this.queryObj.states = "1,2";
      } else {
        this.queryObj.states = this.queryState;
      }
      this.$ajax
        .get("/buss/fault/list", this.queryObj)
        .then((msg) => {
          this.pageData = msg;

          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    //初始化区域下拉框
    loadAreaListAll () {
      this.assets = [];
      let orgid;
      if (this.faultInfo.orgId instanceof Array) {
        orgid = this.$refs.orgId.getCheckedNodes()[0].value;
      } else {
        orgid = this.faultInfo.orgId;
      }

      this.$ajax
        .get("/base/area/list_all", { orgIds: orgid })
        .then((msg) => {
          this.areas = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    //初始化设备模块下拉框
    loadModuleListAll () {
      this.$ajax
        .get("/base/module/list_all", {
          typeId: this.faultInfo.equiTypeId,
        })
        .then((msg) => {
          this.modules = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //初始化故障现象下拉框
    loadFauAppeListAll () {
      this.$ajax
        .get("/base/fauAppe/list_all", {
          typeId: this.faultInfo.equiTypeId,
        })
        .then((msg) => {
          this.appes = msg;
          this.appes.push({
            id: 999999,
            name: "自定义",
          });
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    //初始化故障等级下拉框
    loadFauLevelListAll () {
      this.$ajax
        .get("/base/faultlevel/list_all", {})
        .then((msg) => {
          this.levels = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    //初始化自定义列表
    loadExtendListAll (func) {
      this.extendMetaData = [];
      this.extendData = [];
      this.$ajax
        .get("/base/faucusfield/listall", {
          typeId: 1,
        })
        .then((msg) => {
          let fathers = [];
          msg.forEach((e) => {
            if (e.dictFatherId != null) {
              fathers.push(e.dictFatherId);
            }
          });
          fathers = Array.from(new Set(fathers));
          if (fathers != null && fathers.length > 0) {
            this.$ajax
              .get("/base/dic/listsonsbyfathers", {
                fathers: fathers.join(","),
              })
              .then((m) => {
                console.log(msg);
                msg.forEach((e) => {
                  if (e.dictFatherId != null) {
                    if (e.dicts == null) {
                      e.dicts = [];
                    }

                    m.forEach((em) => {
                      if (em.father_id == e.dictFatherId) {
                        e.dicts.push(em);
                      }
                    });
                  }
                });
                this.extendMetaData = msg;
                console.log(this.extendMetaData);
                console.log(this.extendData);
                if (func != null) {
                  console.log(2);
                  func();
                }
              })
              .catch((err) => {
                this.$message.error(err);
              });
          } else {
            this.editLoading = false;
            this.extendMetaData = msg;
            if (func != null) {
              func();
            }
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    queryFaultList (orgIds) {
      this.queryObj.pageNum = 1;
      if (orgIds != null && orgIds != []) {
        this.queryObj.orgIds = orgIds.join(",");
      }
      this.loadFaultList();
    },

    //初始化添加故障
    add_init () {
      this.appes = [];
      this.extendMetaData = [];
      this.extendData = [];
      this.resolverIdArr = [];
      this.faultInfo = {};
      this.assetCode = "";
      this.loadExtendListAll();
      this.editVisible = true;
    },

    //保存故障信息
    submitFault () {
      this.$refs["faultForm"].validate((valid) => {
        if (valid) {
          this.faultInfo.equiName = this.$refs.equiSelect.selected.label;
          this.faultInfo.equiModuleName = this.$refs.equiModuleSelect.selected.label;
          this.faultInfo.appeName = this.$refs.appeSelect.selected.label;
          this.faultInfo.orgId = this.assetInfo.orgId;
          this.faultInfo.orgName = this.assetInfo.orgName;
          this.faultInfo.areaId = this.assetInfo.areaId;
          this.faultInfo.areaName = this.assetInfo.areaName;
          this.faultInfo.equiTypeId = this.assetInfo.typeId;
          this.faultInfo.equiTypeName = this.assetInfo.typeName;
          this.faultInfo.equiModelId = this.assetInfo.modelId;
          this.faultInfo.equiModelName = this.assetInfo.modelName;
          this.faultInfo.systemId = this.assetInfo.systemId;
          this.faultInfo.systemName = this.assetInfo.systemName;

          this.faultInfo.source = 2;

          this.faultInfo.isProf = 0;
          this.faultInfo.isActived = 0;
          this.faultInfo.resolverName =
            this.$refs.resolverSelect.selected.label;
          // var resolverNameArr = this.$refs.resolverSelect.selected.map(
          //   (v) => v.label
          // ); //获取解决人名称数组
          // if (this.resolverIdArr.length > 0) {
          //   this.faultInfo.resolverName = resolverNameArr.join(",");
          //   this.faultInfo.resolverId = this.resolverIdArr.join(",");
          // }
          this.faultInfo.state = 1;
          if (
            this.faultInfo.resolverId != null &&
            this.faultInfo.resolverId != ""
          ) {
            //当填写了解决人，则为待解决状态
            this.faultInfo.state = 2;
          }
          let url = "/buss/fault/add";
          if (this.faultInfo.id != null) {
            url = "/buss/fault/edit";
          }
          this.saving = true;
          this.$ajax
            .post(url, this.faultInfo)
            .then((msg) => {
              this.saving = false;
              this.loadFaultList();
              this.editVisible = false;
              console.log(msg)
              this.$message.success('故障上报成功');
            })
            .catch((err) => {
              this.$message.error(err);
              this.saving = false;
            });
        }
      });
    },
    //删除故障信息
    del (delId) {
      let ids = [];
      if (delId != null) {
        ids = [delId];
      } else {
        this.$refs["faultTable"].selection.forEach((ele) => {
          ids.push(ele.id);
        });
      }
      if (ids.length > 0) {
        this.loading = true;
        this.$ajax
          .post("/buss/fault/delete", { ids: ids })
          .then((msg) => {
            this.loading = false;
            this.$message.success(msg);
            this.queryObj.pageNum = 1; //删除之后，回到第一页
            this.loadFaultList();
          })
          .catch((err) => {
            this.$message.error(err);
            this.loading = false;
          });
      }
    },
    //查看故障详情
    view (row) {
      this.viewVisible = true;
      this.viewLoading = true;
      this.fileListView = [];
      this.$ajax
        .get("/buss/fault/load_detail", { id: row.id })
        .then((msg) => {
          //初始化图片
          if (msg.attachImgs != null && msg.attachImgs != "") {
            let temp = JSON.parse(msg.attachImgs);
            temp.forEach((e) => {
              this.fileListView.push(
                this.$api +
                e.url +
                "&platform=web&token=" +
                this.$store.getUser().token
              );
            });
          }

          this.faultInfo = msg;
          //加载扩展属性
          this.$ajax
            .get("/buss/fault/extend_data", {
              fauId: this.faultInfo.id,
              typeId: 1,
            })
            .then((msg) => {
              this.extendData = msg;
            })
            .catch((err) => {
              this.$message.error(err);
            })
            .finally(() => {
              this.viewLoading = false;
            });
        })
        .catch((err) => {
          this.$message.error(err);
          this.viewVisible = false;
          this.viewLoading = false;
        });
    },
    isProfFormat (row) {
      if (row.isProf == 0) {
        return "否";
      } else {
        return "是";
      }
    },
    isActivedFormat (row) {
      if (row.isActived == 0) {
        return "否";
      } else {
        return "是";
      }
    },
    sourceFormat (row) {
      if (row.source == 1) {
        return "手机端";
      } else {
        return "WEB端";
      }
    },
    //显示状态，type=1列表用，type=2详情用
    stateFormat (row, type) {
      if (row.state == 1) {
        if (type == 1) {
          row.statename = "待分配";
          return "warning";
        }
        return "待分配";
      } else if (row.state == 2) {
        if (type == 1) {
          row.statename = "待解决";
          return "primary";
        }
        return "待解决";
      } else {
        if (type == 1) {
          row.statename = "已解决";
          return "success";
        }
        return "已解决";
      }
    },
    findAppeAndLevelByid () {
      if (this.faultInfo.appeId != 999999) {
        if (this.faultInfo.appeId != "") {
          for (let i = 0, len = this.appes.length; i < len; i++) {
            if (this.appes[i].id == this.faultInfo.appeId) {
              this.$set(this.faultInfo, "levelId", this.appes[i].levelId);
              this.$set(this.faultInfo, "levelName", this.appes[i].levelName);
              this.$set(
                this.faultInfo,
                "duration",
                this.appes[i].standardFaultDuration
              );
              this.$set(this.faultInfo, "appeName", this.appes[i].name);
              this.$set(this.faultInfo, "colorCode", this.appes[i].colorCode);
              break;
            }
          }
        }
      } else {
        this.faultInfo.levelName = "";
        this.$set(this.faultInfo, "duration", 4);
        this.levels = [];
      }
    },
  },
  mounted () {
    this.init();
  },
};
</script>
<style scoped></style>
